var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('v-icon',{attrs:{"color":"warning"}},[_vm._v("mdi-alert-circle-outline")]),_vm._v(" Технические работы на сервере ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }